import * as Yup from 'yup';

import i18n from '@/i18n';

export const setPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, i18n.t('minimumPassword', { ns: 'common' }))
    .required(i18n.t('passwordRequired', { ns: 'common' })),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], i18n.t('passwordMatch', { ns: 'common' }))
    .required(i18n.t('passwordRequired', { ns: 'common' }))
});
